import ReactPDF, { Font, Text as Txt } from "@react-pdf/renderer"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import staticPath from "../../config/staticPath"

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf",
    },
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
      fontWeight: "bold",
    },
  ],
})

Font.register({
  family: "NotoSansSC",
  fonts: [
    {
      src: staticPath("/fonts/noto-sans-sc/noto-sans-sc-regular.otf"),
    },
    {
      src: staticPath("/fonts/noto-sans-sc/noto-sans-sc-bold.otf"),
      fontWeight: "bold",
    },
  ],
})

const Text = ({
  bold = false,
  style,
  children,
  ...props
}: ReactPDF.TextProps & { bold?: boolean }) => {
  const { i18n } = useTranslation()

  useEffect(() => {
    if (i18n.language === "zh_CN") {
      Font.registerHyphenationCallback((word) =>
        Array.from(word).flatMap((char) => [char, ""]),
      )
    } else {
      Font.registerHyphenationCallback((word) => [word])
    }
  }, [i18n])

  return (
    <Txt
      style={{
        fontFamily: i18n.language === "zh_CN" ? "NotoSansSC" : "Roboto",
        ...style,
      }}
      {...props}
    >
      {children}
    </Txt>
  )
}

export default Text
